export default __webpack_public_path__ + "static/media/025-wavy.7fdea64f.svg";